import { environment } from '../../../environments/environment';

export const Config = {
    "cognito": {
        "userPoolId": environment.cognito.userPoolId,
        "userPoolWebClientId": environment.cognito.userPoolWebClientId,
    },
    "localHost":  environment.backend_url,
    "aws_cognito_region": environment.aws_cognito_region,
    "aws_user_pools_id": environment.aws_user_pools_id,
    "aws_user_pools_web_client_id": environment.aws_user_pools_web_client_id,
    "aws_cognito_identity_pool_id": environment.aws_cognito_identity_pool_id,
    "aws_mandatory_sign_in": "enable",
    "Subscription": [
        "Free", "Standard", "Premium", "Enterprise", "Admin"
    ],
    "backend_url": environment.backend_url,
    "websocket_url": environment.websocket_url,
    "image_url": environment.image_url,
    "stripe_pub_key": environment.STRIPE_PUBLISH_TEST_KEY,
    "stripe_secret_key": environment.STRIPE_SECRET_TEST_KEY,
    "signup_team": [
        {id: 1, name: "Marketing"}, {id:2, name: "HR & Legal"}, {id:3, name: "Product & Design"}, 
        {id: 4, name: "Creative Production"}, {id: 5, name: "Engineering"}, {id: 6, name: "Customer Service"},
        {id: 7, name: "Operations"}, {id: 8, name: "Finance"}, {id: 9, name: "IT & Support"},
        {id: 10, name: "Manufacturing"}, {id: 11, name: "Sales & Account Mgmt."},{id: 12, name: "Other / Personal"}
    ],
    "signup_role": [
        {id: 1, name: "Owner"}, {id:2, name: "C-Suite"}, {id:3, name: "Vice President"}, 
        {id: 4, name: "Director"}, {id: 5, name: "Team Leader"}, {id: 6, name: "Team Member"},
        {id: 7, name: "Freelancer"}, {id: 8, name: "Other"}
    ],
    'USER_ACCOUNTS': [
        { id: 1, name: 'Admin' }, 
        { id: 2, name: 'Talonic Staff' }, 
        { id: 3, name: 'Freemium' }, 
        { id: 4, name: 'Individual' }, 
        { id: 5, name: 'Business' }, 
        { id: 6, name: 'Premium' }, 
        { id: 7, name: 'Enterprise' }
    ],
    'businessPlan_year': "https://buy.stripe.com/fZe8zceBP9fG46s7sC",
    'businessPlan_month': "https://buy.stripe.com/3cseXA51f1Ne6eA4gr",
    'individualPlan_year': "https://buy.stripe.com/9AQbLo65j0Ja6eA7sE",
    'individualPlan_month': "https://buy.stripe.com/4gwaHkgJX2RibyUdR3",
    'purchaseCredits': "https://buy.stripe.com/00g8zc1P3dvW32o28m",
    'purchaseTestCredits': "https://buy.stripe.com/test_dR6aFhfId78e1W0eUY",
    'CREDITS': 10
}

export const ACCESS_LEVEL = Object.freeze({
    OWNER: 'owner',
    ADMIN: 'admin',
    USER: 'user'
});

export const SUBSCRIPTION_TIER = Object.freeze({
    ADMIN: 't0',
    TALONIC_STAFF: 't1',
    FREEMIUM: 't2',
    INDIVIDUAL: 't3',
    BUSINESS: 't4',
    PREMIUM: 't5',
    ENTERPRISE: 't6'
});